import type { CharityStatus } from "@/openapi/generated";

export const charityQueryKeys = {
  all: ["charities"] as const,
  list: (params: {
    searchTerm?: string;
    status?: CharityStatus[];
    page?: number;
    size?: number;
    sort?: string[];
  }) => ["charities", "list", params] as const,
  detail: (id: string) => ["charities", "detail", id] as const,
  projects: (charityId: string) => ["charities", "projects", charityId] as const,
  fieldsOfWork: ["charities", "fieldsOfWork"] as const,
  certificates: ["charities", "certificates"] as const,
} as const;
